import defaultUploadRequest from "rc-upload/lib/request";
import type { UploadRequestOption } from "rc-upload/lib/interface";
import security from "../../common/services/SecurityService";

export const authenticatedUploadRequest = (option: UploadRequestOption) => {
    let request: { abort: () => void } | undefined;
    let aborted = false;

    security
        .invoke((token) => {
            if (aborted) {
                return Promise.resolve();
            }

            request = defaultUploadRequest({
                ...option,
                headers: {
                    ...option.headers,
                    Authorization: `Bearer ${token}`,
                },
            });

            return Promise.resolve();
        })
        .catch((err) => {
            if (!aborted) {
                option.onError?.(
                    err instanceof Error
                        ? err
                        : new Error("Upload authentication failed."),
                );
            }
        });

    return {
        abort() {
            aborted = true;
            request?.abort();
        },
    };
};
